import { admin2 } from '@/api/instance'

const baseUrl = (shopId) => {
  return `/${shopId}/kachogawaAppointmentPickupOverview`
}

//= > 花鳥川 — 取得預約備貨總覽統計
export const GetKachogawaAppointmentPickupOverview = async ({
  shopId,
  startDate,
  endDate,
  appointmentCategoryId,
  status,
}) => {
  return await admin2({
    method: 'get',
    url: baseUrl(shopId),
    params: {
      startDate,
      endDate,
      appointmentCategoryId,
      status,
    },
  })
}
